var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMenu3DActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_13097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2499 15C12.5999 15 12.9399 14.92 13.2599 14.76L14.7599 14.01C15.5199 13.63 16.0099 12.85 15.9999 12V9.77C15.9999 8.92 15.5199 8.14 14.7599 7.76L13.2599 7.01C12.6299 6.69 11.8799 6.69 11.2499 7.01L9.74988 7.76C8.98988 8.14 8.49988 8.92 8.50988 9.77V12C8.50988 12.85 8.98988 13.63 9.74988 14.01L11.2499 14.76C11.5599 14.92 11.9099 15 12.2599 15H12.2499ZM9.99988 12V9.77C9.99988 9.69 10.0099 9.62 10.0399 9.55L11.6699 10.37C12.0299 10.55 12.4599 10.55 12.8199 10.37L14.4499 9.55C14.4699 9.62 14.4899 9.7 14.4899 9.77V12C14.4899 12.28 14.3299 12.54 14.0799 12.67L12.5799 13.42C12.3699 13.52 12.1199 13.52 11.9099 13.42L10.4099 12.67C10.1599 12.54 9.98988 12.28 9.99988 12ZM17.4999 19.5H15.4699L18.0899 17.08C21.3099 13.86 21.3099 8.63 18.0899 5.41C14.8699 2.19 9.63988 2.19 6.41988 5.41C3.19988 8.63 3.19988 13.86 6.41988 17.08L9.03988 19.5H7.00988C6.59988 19.5 6.25988 19.84 6.25988 20.25C6.25988 20.66 6.59988 21 7.00988 21H17.5099C17.9199 21 18.2599 20.66 18.2599 20.25C18.2599 19.84 17.9199 19.5 17.5099 19.5H17.4999ZM7.47988 6.48C10.1099 3.83999 14.3799 3.82999 17.0299 6.46C19.6699 9.09 19.6799 13.36 17.0499 16.01L14.0599 18.77C13.0399 19.73 11.4499 19.73 10.4299 18.76L7.47988 16.03C4.84988 13.39 4.84988 9.10999 7.47988 6.48Z",
    fill: "#242628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_13097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 18,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenu3DActive);
export default __webpack_public_path__ + "static/media/ico-menu-3d-active.847555a0528388f4e07a7c87c38edba8.svg";
export { ForwardRef as ReactComponent };